import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"vehicle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10 19H23V14L22.6 13H16.5H10.4L10 14V19Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M23.0002 19H10.0002M23.0002 19V14L21.0002 9H12.0002L9.9502 13.975L10.0002 19M23.0002 19V20.5M10.0002 19V20.5M21.8502 13H11.1502M20.0002 16.0039H20.0041V16H20.0002V16.0039ZM13.0002 16.0039H13.0041V16H13.0002V16.0039Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M1 13V18C1 18.5523 1.44772 19 2 19H7M1 13V5C1 4.44772 1.44772 4 2 4H13C13.5523 4 14 4.44772 14 5V6M1 13H7M4.5 19.5L3.5 20.5M4 16.0039H4.00391V16H4V16.0039Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Vehicle = Vue.extend<IconProps>({
  name: 'VehicleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'vehicle',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Vehicle;
